import { useTranslation } from 'react-i18next';
import { Loader } from 'rsuite';
import { Table, TableBody, TableContainer } from '@mui/material';
import EmptyData from '@shared/ui/messages/EmptyData';
import { PER_PAGE } from '@utils/tables/params';
import { useTableMaxHeight } from '@utils/tables/useTableMaxHeight';
import CustomTableHead from '@widgets/tables/main/CustomTableHead';
import CustomTablePagination from '@widgets/tables/main/CustomTablePagination';

export default function CustomTable({
  columns,
  children,
  params,
  setParams,
  filteredCount,
  selected,
  setSelected,
  data,
  hidePagination,
  isLoading,
  isInitialized,
  search,
  filtersCount,
}) {
  const { t } = useTranslation();
  const isFirstLoading = isLoading && !isInitialized;
  const hasData = data?.length > 0 && isInitialized;
  const showFooter = !hidePagination && (hasData || isFirstLoading);
  const { containerRef, footerRef, maxHeight } = useTableMaxHeight(!showFooter);

  return (
    <>
      <TableContainer
        ref={containerRef}
        sx={{
          maxHeight: maxHeight || 'calc(100vh - 72px)',
          minHeight: 0,
          flex: 1,
        }}
      >
        {isFirstLoading && <Loader center />}
        {hasData && (
          <Table className="custom-table" stickyHeader>
            <CustomTableHead
              columns={columns}
              params={params}
              setParams={setParams}
              selected={selected}
              setSelected={setSelected}
              data={data}
            />
            <TableBody>{children}</TableBody>
          </Table>
        )}
        {data?.length === 0 && isInitialized && !isLoading && (
          <EmptyData
            text={
              search || filtersCount
                ? t('nothing_yet_change_filters')
                : t('no_data_found')
            }
          />
        )}
      </TableContainer>

      {showFooter && (
        <div
          ref={footerRef}
          className={
            isFirstLoading ? 'custom-table-footer--loading' : undefined
          }
        >
          {hasData && (
            <CustomTablePagination
              page={params.page || 1}
              perPage={params.per_page || PER_PAGE}
              setPage={(value) => setParams({ ...params, page: value })}
              setPerPage={(value) =>
                setParams({ ...params, per_page: value, page: 1 })
              }
              filteredCount={filteredCount}
              selected={selected}
            />
          )}
        </div>
      )}
    </>
  );
}
